// extracted by mini-css-extract-plugin
export default {"modalContent":"styles_modalContent__a2nNR","titleContent":"styles_titleContent__B8zMJ","mfaInputContainer":"styles_mfaInputContainer__9Xnqk","mfaInput":"styles_mfaInput__GUSkn"};